import type { ReactNode } from 'react'

type PopoverButtonProps = {
  children: ReactNode
}

const PopoverButton = ({ children }: PopoverButtonProps) => {
  return <button className='hot-button'>{children}</button>
}

export default PopoverButton
